<template>
    <div class="ag-checkbox-header">
        <v-checkbox
            v-model="isChecked"
            aria-label="Select all"
            hide-details
            dense
            :indeterminate="isIndeterminate"
            @change="onChange"
        />
    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    data() {
        return {
            isChecked: false,
            isIndeterminate: false,
        };
    },
    mounted() {
        this.updateCheckboxState();
        this.params.api.addEventListener('selectionChanged', this.updateCheckboxState);
    },
    beforeUnmount() {
        this.params.api.removeEventListener('selectionChanged', this.updateCheckboxState);
    },
    methods: {
        updateCheckboxState() {
            const selected = this.params.api.getSelectedRows().length;
            const total = this.params.api.getDisplayedRowCount();

            if (selected === 0) {
                this.isChecked = false;
                this.isIndeterminate = false;
            } else if (selected === total) {
                this.isChecked = true;
                this.isIndeterminate = false;
            } else {
                this.isChecked = false;
                this.isIndeterminate = true;
            }
            // For native indeterminate support
            if (this.$refs.checkbox) {
                this.$refs.checkbox.indeterminate = this.isIndeterminate;
            }
        },
        onChange(checked) {
            if (this.isIndeterminate) {
                this.params.api.deselectAll();
                this.globalEmit('select-all-changed', false);
                return;
            }
            if (checked) {
                this.params.api.selectAllFiltered();
            } else {
                this.params.api.deselectAll();
            }
            this.globalEmit('select-all-changed', checked);
        },
    },
});
</script>

<style scoped>
::v-deep {
    .v-icon.v-icon {
        font-size: 2rem !important;
    }

    .v-input {
        margin: 0;
    }
}
</style>
